import { Link } from "react-router-dom";
import SEOHead from "../components/SEOHead";

export default function NotFoundPage() {
  return (
    <>
      <SEOHead
        title="Page introuvable (404) | MarocPratique"
        description="Cette page n'existe pas ou a été déplacée."
        noIndex={true}
      />
      <div
        data-testid="not-found-page"
        className="max-w-2xl mx-auto px-4 py-24 text-center"
      >
        <p className="text-8xl font-heading font-bold text-blue-100 select-none">404</p>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 mt-4 mb-3">
          Page introuvable
        </h1>
        <p className="text-slate-500 text-base mb-8">
          La page que vous cherchez n'existe pas ou a été déplacée.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition-colors"
          >
            Retour à l'accueil
          </Link>
          <Link
            to="/categorie/administratif"
            data-testid="not-found-admin-link"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white border border-slate-200 text-slate-700 font-semibold rounded-xl hover:bg-slate-50 transition-colors"
          >
            Voir les démarches
          </Link>
        </div>
      </div>
    </>
  );
}
